import React, { useState, useEffect } from 'react';
import './NavbarMobile.css';
import { Link as Anchor, useNavigate, useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faShoppingCart, faSearch, faHome, faPlus, faUser, faDownload } from '@fortawesome/free-solid-svg-icons';
import BtnWhatsapp from '../BtnWhatsapp/BtnWhatsapp'
import LinksNav from '../LinksNav/LinksNav'
import Favoritos from '../Favoritos/Favoritos'
import InputSerach from '../InputSerach/InputSearchs'
export default function NavbarMobile() {
    const location = useLocation();
    const [modalOpen, setModalOpen] = useState(false);


    const openModal = () => {
        setModalOpen(!modalOpen);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <section className='scrolledMobile'>
            <Anchor to={`/`} className={location.pathname === '/' ? 'active' : ''} onClick={closeModal} aria-label="Ir a la página de inicio">
                <FontAwesomeIcon icon={faHome} />
                <strong>Inicio</strong>

            </Anchor>
            < BtnWhatsapp />
            <div className='plus'>
                <LinksNav />
            </div>
            <Favoritos />
            <button
                type="button"
                className="btnInstallMobileNav"
                onClick={() => window.dispatchEvent(new CustomEvent('open-pwa-install'))}
                title="Instalar App en tu celular"
                aria-label="Instalar aplicación en el dispositivo"
            >
                <FontAwesomeIcon icon={faDownload} />
                <strong>Instalar</strong>
            </button>
            <InputSerach />


        </section>
    );
}
